import { FORM_MODES } from 'modules/campaigns/config/index';
import { generateCreativeEditorPath } from 'modules/campaigns/services/utils';
import { mergeQueryParams } from '../../../../taboola-common-frontend-modules/query-params';
import { cleanCreativesEditingResources } from '../../creative-editor/flows';
import { INITIAL_CREATIVE_TYPE } from '../../creative-editor/hooks/useInitialCreativeType';

const baseEditCreative =
    ({ accountId, campaignId, creativeId, navigate, creativeType, dimension }) =>
    dispatch => {
        const editCreativePath = generateCreativeEditorPath({
            accountId,
            campaignId,
            creativeId,
            mode: FORM_MODES.EDIT,
            dimension,
        });
        dispatch(cleanCreativesEditingResources());

        const pathWithCreativeType = `${editCreativePath}${mergeQueryParams('', {
            [INITIAL_CREATIVE_TYPE]: creativeType,
        })}`;

        navigate(pathWithCreativeType);
    };

export default baseEditCreative;
